<script>
  import Icon from "../../components/Icon/Icon.svelte";
  import Selects from "./header/Selects.svelte";
  import Search from "./header/Search.svelte";
  let isHeaderOpen = false;
  function showHeaderMenu(event) {
    isHeaderOpen = !isHeaderOpen;
  }
</script>

<header class="header" class:js-header--open={isHeaderOpen}>
  <div class="header__wrapper">
    <Search />
    <Selects />
  </div>

  <!-- Hamburger icon start -->
  <div class="header__menu" on:click={showHeaderMenu}>
    <Icon kod="011" />
  </div>
  <!-- Hamburger icon end -->
</header>
